<div
  class="container"
  [@fadeInOut]="article"
>
  <h3>
    {{ article.title }}
  </h3>

  <div
    [innerHTML]="article.description"
    class="article-wrapper"
  ></div>
</div>
